<template>
  <div>
    <div
      class="flex space-x-4 overflow-x-auto whitespace-nowrap mb-4 border-b border-grey-12 dark:border-dark-border"
    >
      <button
        v-for="tab in tabs"
        :key="tab.name"
        class="transition-all flex flex-col items-center hover:text-black dark:hover:text-dark-ink text-grey-11 dark:text-dark-ink-muted"
        @click="selectTab(tab.name)"
      >
        <span class="text-sm lg:text-base mb-2">{{ tab.label }}</span>
        <div
          class="h-1 w-full transition-colors duration-200"
          :class="[
            selectedTab.name === tab.name ? 'bg-red-1' : 'bg-transparent',
          ]"
        ></div>
      </button>
    </div>
    <div class="tab-content">
      <slot :name="selectedTab.name"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
})

const route = useRoute()
const router = useRouter()

// Get initial tab from hash or default to first
const getTabFromHash = () => {
  const hash = route.hash?.slice(1)
  return props.tabs.find((t) => t.name === hash) || props.tabs[0]
}

const selectedTab = ref(getTabFromHash())

const selectTab = (tabName) => {
  const tab = props.tabs.find((t) => t.name === tabName)
  if (tab && tab !== selectedTab.value) {
    selectedTab.value = tab
    router.replace({ query: route.query, hash: `#${tab.name}` })
  }
}

// Watch for route hash changes (e.g., browser back/forward)
watch(
  () => route.hash,
  (newHash) => {
    const hash = newHash?.slice(1)
    const tab = props.tabs.find((t) => t.name === hash)
    if (tab && tab !== selectedTab.value) {
      selectedTab.value = tab
    }
  }
)
</script>
